import { Fragment, FunctionalComponent, h } from 'preact';

import { configGetCountry } from 'common/helper/config/get-country';
import { domClassMerge } from 'common/helper/dom/class-merge';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { GoogleRecaptchaTemplate } from 'common/module/google/recaptcha/template';
import { IconEnvelopeFilledTemplate } from 'common/module/icon/envelope-filled-template';
import { IconFacebookFilledTemplate } from 'common/module/icon/facebook-filled-template';
import { IconGoogleFilledTemplate } from 'common/module/icon/google-filled-template';
import { IconThickArrowLeft } from 'common/module/icon/thick-arrow-left';
import { IconThickTimes } from 'common/module/icon/thick-times';
import { LoaderComponent } from 'common/module/loader/component';
import { UserRegistrationComponent } from 'common/module/user/registration/component';
import { UserSignInTemplatePropsInterface } from 'common/module/user/sign-in/template-props.interface';

const authText = i18nTranslate(`By registering you accept our {link} and {link}`);
const authTextParts = authText.split('{link}');

export const UserSignInTemplateRefactored: FunctionalComponent<UserSignInTemplatePropsInterface> = (props) => {
  const authHeader = () => (
    <Fragment>
      <button
        type='button'
        className={domClassMerge('authentication__toggle-button--refactored', {
          'authentication__toggle-button--active--refactored': props.activePage === 'create',
        })}
        onClick={() => props.setActivePage('create')}
      >
        {i18nTranslate('Create account')}
      </button>
      <button
        type='button'
        className={domClassMerge('authentication__toggle-button--refactored', {
          'authentication__toggle-button--active--refactored': props.activePage === 'login',
        })}
        onClick={() => props.setActivePage('login')}
      >
        {i18nTranslate('Log in')}
      </button>
    </Fragment>
  );

  const authButtons = () => (
    <Fragment>
      <button
        type='button'
        className='authentication__btn authentication__btn--refactored authentication__btn--refactored authentication__btn--google--refactored'
        onClick={props.onClickSignInGoogle}
      >
        <span className='svg'>
          <IconGoogleFilledTemplate class='authentication__cta-icon--refactored' />
        </span>
        <span>{i18nTranslate(props.activePage === 'create' ? 'Continue with Google' : 'Login with Google')}</span>
      </button>
      <button
        type='button'
        className='authentication__btn authentication__btn--refactored authentication__btn--refactored authentication__btn--facebook'
        onClick={props.onClickSignInFacebook}
      >
        <span className='svg'>
          <IconFacebookFilledTemplate class='authentication__cta-icon--refactored' />
        </span>
        <span>{i18nTranslate(props.activePage === 'create' ? 'Continue with Facebook' : 'Login with Facebook')}</span>
      </button>
      <button
        type='button'
        className='authentication__btn authentication__btn--refactored authentication__btn--refactored authentication__btn--email--refactored'
        onClick={() => {
          props.activePage === 'create' ? props.setIsRegisterActive(true) : props.setIsLoginActive(true);
        }}
      >
        <span>
          <IconEnvelopeFilledTemplate class='authentication__btn-envelope--refactored' />
        </span>
        <span>{i18nTranslate(props.activePage === 'create' ? 'Continue with email' : 'Login with email')}</span>
      </button>
    </Fragment>
  );

  const authFormRegister = () => <UserRegistrationComponent />;

  const authFormLogin = () => (
    <div className='authentication__form'>
      <div className='authentication__input-area'>
        <input
          type='text'
          className='authentication__input authentication__input--refactored'
          placeholder={i18nTranslate('Email')}
          value={props.fields.email}
          onKeyUp={props.onKeyUpInput}
          onChange={(e: Event) => props.onChangeInput(e, 'email')}
        />
        <div className='authentication__error'>{props.fieldErrors.email}</div>
      </div>
      <div className='authentication__input-area'>
        <input
          type={props.isPasswordVisible ? 'text' : 'password'}
          className='authentication__input authentication__input--refactored'
          placeholder={i18nTranslate('Password')}
          value={props.fields.password}
          onKeyUp={props.onKeyUpInput}
          onChange={(e) => props.onChangeInput(e, 'password')}
        />
        <button
          type='button'
          className='authentication__input-area-password-show-hide--refactored'
          onClick={() => props.setIsPasswordVisible(!props.isPasswordVisible)}
        >
          {i18nTranslate(props.isPasswordVisible ? 'Hide' : 'Show')}
        </button>
        <div className='authentication__error'>{props.fieldErrors.password}</div>
      </div>
      <button type='button' className='authentication__forgot-password' onClick={props.onClickForgotPassword}>
        {i18nTranslate('Forgot password?')}
      </button>

      <div className='authentication__input-area'>
        <GoogleRecaptchaTemplate {...props.captcha} />
        <div className='authentication__error'>{props.fieldErrors.captcha_token}</div>
      </div>

      <div className='authentication__form-submit'>
        <button type='button' className='button authentication__button--refactored' onClick={props.onClickLogin}>
          {i18nTranslate('Log in')}
        </button>
      </div>
    </div>
  );

  const policyText = () => (
    <div className='authentication__policy-check authentication__policy-check--refactored'>
      <div className='authentication__compliance-text authentication__compliance-text--refactored'>
        {authTextParts[0]}
        <a
          href={configGetCountry().termsUrl}
          target='_blank'
          className='authentication__compliance-link authentication__compliance-link--refactored'
          rel='noreferrer'
        >
          {i18nTranslate('Terms and Conditions')}
        </a>
        {authTextParts[1]}
        <a
          href={configGetCountry().privacyPolicyUrl}
          target='_blank'
          className='authentication__compliance-link authentication__compliance-link--refactored'
          rel='noreferrer'
        >
          {i18nTranslate('Privacy Policy')}
        </a>
        {authTextParts[2]}
      </div>
    </div>
  );

  return (
    <div className='authentication--refactored'>
      <div className='authentication__close-button--refactored'>
        <button type='button' className='authentication__back-icon-container--refactored' onClick={props.onBack}>
          <IconThickArrowLeft
            class={domClassMerge('authentication__back-icon--refactored', {
              'authentication__back-icon--hidden--refactored': !props.isLoginActive && !props.isRegisterActive,
            })}
          />
        </button>
        <button type='button' onClick={props.onClose}>
          <IconThickTimes class='authentication__back-icon--refactored' />
        </button>
      </div>
      <div className='authentication__heading--refactored'>{i18nTranslate('Almost done')}...</div>
      <div className='authentication__description--refactored'>
        {i18nTranslate('Finish setting up your property alert by registering or signing in to Property Finder')}
      </div>
      <div className='authentication__content'>
        <div className='authentication__toggle-header--refactored'>{authHeader()}</div>
        <div className='authentication__toggle-body--refactored'>
          {!props.isLoginActive && !props.isRegisterActive && authButtons()}
          {props.error && <div className='authentication__error--general'>{props.error}</div>}
          {props.isLoginActive && authFormLogin()}
          {props.isRegisterActive && authFormRegister()}
          {props.activePage === 'create' && policyText()}
        </div>
      </div>
      <LoaderComponent isEnabled={props.loaderEnabled} isCentered={true} />
    </div>
  );
};
